import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import KuposDatePicker from './KuposDatePicker';
import KuposTimePicker from './KuposTimePicker';
import DateService from '../../services/dateService';

export class KuposDateTimePicker extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    selectedStartDate: PropTypes.string,
    selectedStartTime: PropTypes.string,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    minDate: PropTypes.string,
    onDateChange: PropTypes.func,
    placeholder: PropTypes.string,
    deactivatePastDate: PropTypes.bool,
    canChangeYear: PropTypes.bool,
    style: PropTypes.object,
    canEraseDate: PropTypes.bool,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      // showOnSelect:false
    };
  }

  componentDidMount() {
    // this.setState({ dateTimeCleared: false });
  }
  onDateChangeInternal = val => {
    this.props.onDateChange(val, 'date');
    this.setState({ showOnSelect: true });
  };

  clearDateTime = () => {
    this.setState({ showOnSelect: false });
    this.props.clearDateTime();

    // if (this.props.optionalDatePicker && document.getElementById('at-optional-datebox'))
    //   document.getElementById('at-optional-datebox').classList.add('optional-box');
  };

  onDateFocus = () => {
    this.setState({ showOnSelect: false });

    // if (this.props.optionalDatePicker && document.getElementById('at-optional-datebox')) {
    //   document.getElementById('at-optional-datebox').classList.remove('optional-box');
    // }
  };

  onDateBlur = () => {
    this.setState({ showOnSelect: false });

    //TRYING TO MAKE OPTIONAL DATE BOX AGAIN SMALL WHEN NO DATE IS SELECTED
    // setTimeout(() => {
    //   if (
    //     !this.props.selectedDate &&
    //     this.props.optionalDatePicker &&
    //     document.getElementById('at-optional-datebox')
    //   ) {
    //     document.getElementById('at-optional-datebox').classList.add('optional-box');
    //   }
    // }, 500);
  };

  render() {
    // console.log('props in kupos date time------------', this.props);
    return (
      <div className="common-kupos-date-time-picker">
        <div
          className="date-time-container"
          style={this.props.optional ? { backgroundColor: '#dedcd8' } : {}}
          // onClick={() => this.onDateTimeInFocus()}
        >
          <div style={{ flex: 1.6 }}>
            <KuposDatePicker
              selectedDate={DateService.changeDateFormat(
                this.props.selectedDate,
                'dd-mm-yyyy',
                'dd/mm/yyyy',
              )}
              onDateChange={val => this.onDateChangeInternal(val)}
              minDate={
                this.props.optionalDatePicker
                  ? this.props.transferData.selectedStartDate
                  : DateService.getTodayString()
              }
              // error={this.state.transferDateError ? true : false}
              // errorMessage={this.state.transferDateError}
              placeholder={
                this.props.optional
                  ? this.props.t('HOME.OPTIONAL_DATE')
                  : this.props.t('HOME.SELECT_DATE')
              }
              newStyle="border-less-date-input"
              disabled={this.props.disabled}
              optional={this.props.optional}
              // onFocus={this.onFocus}
              fontSize="font10"
              onFocus={this.onDateFocus}
              onBlur={this.onDateBlur}
              optionalDatePicker={this.props.optionalDatePicker}
            />
          </div>

          <div style={{ flex: 1 }}>
            {this.state.showOnSelect || this.props.showTimeInitially ? (
              <KuposTimePicker
                value={this.props.selectedTime ? this.props.selectedTime : null}
                onChange={val => this.props.onTimeChange(val, 'time')}
                placeholder={this.props.optional ? '' : '00:00'}
                newStyle="border-less-time-input"
                hideIcon={true}
                fullWidthPicker={true}
                showIconsOnAmPm={true}
                showAmPm={this.props.optional ? false : true}
                disabled={this.props.disabled}
                optional={this.props.optional}
                showOnSelect={this.state.showOnSelect}
                fontSize="font10"
                timePickerTitle={this.props.timePickerTitle}
                t={this.props.t}
              />
            ) : null}
          </div>
          {this.props.optionalDatePicker && this.props.selectedDate ? (
            <div className="cross mr-1" onClick={() => this.clearDateTime()}>
              <img className="input-cross" src="/static/images/icons/home/at-x-mark.png" />
            </div>
          ) : null}
        </div>

        {this.props.error ? <span className="error font9">{this.props.errorMessage}</span> : null}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KuposDateTimePicker);



// WEBPACK FOOTER //
// ./src/features/common/KuposDateTimePicker.js